import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { TenantRepository } from './data/tenant.repository';
import { TenantRepositoryHttp } from './data/tenant.repository.http';

/**
 * Provide Tenant Configuration
 *
 * Configures tenant repository based on environment.
 * Uses mock implementation for development.
 */
export function provideTenant(): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: TenantRepository,
      useClass: TenantRepositoryHttp
    },
  ]);

  // return makeEnvironmentProviders([
  //   {
  //     provide: TenantRepository,
  //     useClass: TenantRepositoryMock, // TODO: Switch to real implementation when backend ready
  //   },
  // ]);
}
